import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { CaseNotes } from '@/features/case-notes'

export const Route = createFileRoute('/_authenticated/_organization/case-notes/')({
  beforeLoad: async () => requireRoles(['support_coordinator']),
  component: CaseNotes,
})
